
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import { _ as _objectSpread } from './_rollupPluginBabelHelpers-mixin.js';
import Notification from 'element-ui/lib/notification';

var script = {
  name: 'Notification'
};

const __vue_script__ = script;
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = undefined;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "notification.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

__vue_normalize__({}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

const NOTIFICATION_DEFAULTS = {
  duration: 8000
};
function PendoNotification(config) {
  config.customClass = `pendo-notification ${config.customClass ? config.customClass : ''}`;

  if (config && !config.message) {
    config.customClass += ' is-title-only';
  }

  return Notification(_objectSpread({}, NOTIFICATION_DEFAULTS, config));
}

export default PendoNotification;
